// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "c8e26dd5" + "." + "0344c5c833115cc5" + ".js";
};